<template>
<div>
<div v-if="isLoading" class="loading">Loading&#8230;</div> 



<!-- <div v-if="is_sending" class="positioning-container">
    <div class="spinning-container">
        <div class="airplane-container"><span class="fa fa-plane"></span></div>
    </div>
</div> -->

<!-- <div class="lds-ripple"><div></div><div></div></div> -->

<!-- <div v-if="isLoading==false">  -->

<div class="columns has-background-white is-multiline is-gapless" style="margin-bottom:0em;">

    <!-- TITlE  -->
    <div class="column is-4 is-uppercase underIT has-text-centered has-text-weight-bold is-size-4">Envoyer un message</div>
    <div class="column is-1">&nbsp;</div>
    <div v-if="check_can_sms()" class="column is-2"><a class="button is-fullwidth has-background-info has-text-white has-text-weight-bold" @click="msg_type='SMS'"><span class="icon is-large"><i class="fas fa-sms"></i></span>&nbsp;&nbsp;PAR SMS</a></div>
    <div v-if="check_can_email()" class="column is-2"><a class="button is-fullwidth has-background-info has-text-white has-text-weight-bold" @click="msg_type='EMAIL'"><span class="icon is-large"><i class="far fa-envelope"></i></span>&nbsp;&nbsp;PAR EMAIL</a></div>

    <div class="column is-3 has-text-right">STUDENTS : {{student_cnt}} &nbsp;&nbsp;</div>
    <div class="column is-12">&nbsp;</div>

</div>
<!-- END HEADER ROW  -->


<!-- CHECK IF TYPE NOT SELECTED  -->
    <div v-if="msg_type==''" class="columns has-background-white is-multiline is-gapless box has-background-grey-light" style="margin-bottom:0em;">
        <div class="column is-12">Sélectionnez le type de message</div>
    </div>


<!-- MESSAGE TYPE SELECTED -->
<div v-else class="columns has-background-white is-multiline is-gapless box has-background-grey-light" style="margin-bottom:0em;">

    <!-- SMS -->
    <div v-if="msg_type=='SMS'" class="column is-12">
    <div class="columns is-gapless is-multiline">
        <div class="column is-12"> <!-- MESSAGE BOX  -->
            <textarea v-model="msg_body" rows="2" class="textarea" placeholder="Enter Message ...."></textarea>
        </div>
    </div></div>
    <!-- END SMS -->

    <!-- EMAIL -->
    <div v-if="msg_type=='EMAIL'" class="column is-12">
    <div class="columns is-gapless is-multiline">
        <div class="column is-6">  <!-- SUBJECT FOR EMAIL ~  -->
            <input v-model="msg_subject" class="input is-fullwidth has-text-left has-text-weight-bold" type="text" placeholder="sujet (email)" value="">
        </div>
        <div class="column is-12"> <!-- MESSAGE BOX  -->
            <textarea v-model="msg_body" rows="2" class="textarea" placeholder="Enter Message ...."></textarea>
        </div>
    </div></div>
    <!-- END EMAIL -->
</div>
<!-- END MESSAGE TYPE SELECTED --> 


<div class="columns has-background-white is-multiline is-gapless box has-background-grey-light" style="margin-bottom:0em;">

<!-- SPACER -->
<!-- <div class="column is-12">&nbsp;</div> -->

        <!-- LIST OF STUDENTS  -->
        <div class="column is-3 colBorderThin" v-for="(data,index) in data_students" :key="index">
        <div class="columns is-gapless">
            <div class="column is-10">
                <div class="columns is-gapless is-multiline has-background-light">
                    <div class="column is-12 has-text-weight-bold mt-1">&nbsp;{{data.student_lNAME}}</div>
                    <!-- <div class="column is-12 is-size-7" style="margin-top:-.5em;">&nbsp;{{data.student_fNAME}}</div> -->
                    <div class="column is-12 is-size-7" style="margin-top:-.5em;">&nbsp;{{data.student_TelHome}}</div>
                </div>    

            </div>
            <div class="column is-2" v-if="check_phone_valid(data.student_TelHome, index)">
                <a v-if="+data.goodToGo == true" class="button is-fullwidth has-background-white has-text-success" @click="toggle_send(index)"><span class="icon is-small"><i class="fas fa-check-circle"></i></span></a>
                <a v-else-if="+data.isSent == true" class="button is-fullwidth has-background-green has-text-white" @click="toggle_send(index)"><span class="icon is-small"><i class="fas fa-check-circle"></i></span></a>
                <a v-else class="button is-fullwidth has-background-white has-text-danger" @click="toggle_send(index)"><span class="icon is-small"><i class="fas fa-times-circle"></i></span></a>
            </div>
        </div></div>

<div class="column is-12">&nbsp;</div>

    <div class="column is-3">
            <button @click="emit_close_modal()" class="button is-fullwidth has-background-danger has-text-white">
                <span class="icon is-small has-text-left"><i class="fas fa-window-close"></i></span>     
            </button> 
    </div>
    <div class="column is-3"></div>  <!-- SPACE  -->
    <div v-if="msg_type != ''" class="column is-6">
            <button @click="send_message_confirm()" class="button is-fullwidth has-background-success has-text-white">
                <span class="icon is-small has-text-left"><i class="fas fa-paper-plane"></i>&nbsp;&nbsp;{{msg_type}}</span>      
            </button> 
    </div>

    </div> <!-- END MAIN COLUMNS  -->
    


<!-- </div> -->


</div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

export default {
        props: [ 'data_students' , 'student_cnt', 'group_id' ],
        components: {  },
 
        data() {
            return {
                 isLoading:false,
                 data_student:[],
                 data_history:[],


is_sending:false,

msg_type : '',
msg_count:this.student_cnt,

msg_from : '',

msg_confirm_msg : '',
msg_subject:'',
msg_body:'',
msg_body_html:'',

msg_addresses: '',
msg_student_ids:'',

show_confirm:false,

            }
        },


mounted() {
    this.msg_type = ''
    this.msg_count = this.student_cnt
},

methods : {

check_phone_valid:function(p, index) {

  var phoneRe = /^[2-9]\d{2}[2-9]\d{2}\d{4}$/;
  var digits = p.replace(/\D/g, "");
  if (phoneRe.test(digits)) {return true}
  else {this.data_students[index].isValid = false ; return false}

},


emit_close_modal:function(isSent) {
    this.msg_type = ''
    this.msg_subject = ''
    this.msg_body = ''
    this.msg_count = 0    
    this.$emit('emit_close_modal',isSent)
},

toggle_send:function(index) {
    this.data_students[index].goodToGo = !+this.data_students[index].goodToGo

    if (+this.data_students[index].goodToGo) {this.student_cnt++} else {this.student_cnt--}

},

check_can_email:function() {
// CHECK IF COLLEGE CAN EMAIL/SMS
    if (sessionStorage.getItem('college_canEMAIL'))
    {return true}
    else {return false}
},
check_can_sms:function() {
// CHECK IF COLLEGE CAN EMAIL/SMS
    if ( sessionStorage.getItem('college_canSMS'))
    {return true}
    else {return false}
},

format_date:function(dt) {
    var return_date = moment(dt).format("MMM-DD-YY");  
    var return_time = moment.utc(dt, "HH:mm:ss").add(1, 'h').format("hh:mm A");
    return  return_date + " " + return_time

},


send_message_confirm:function() {
    // this.note_index = index 
    // this.data_notes[index].is_selected = !this.data_notes[index].is_selected
    this.$snotify.confirm('SEND ' + this.msg_type + ' ?', { timeout: 5000, showProgressBar: true, closeOnClick: false, pauseOnHover: false,
    position: "rightBottom",
        buttons: [
            {text: 'Yes', action: (toast) => this.send_message_do(toast)},
            {text: 'No', action: (toast) => this.$snotify.remove(toast.id)},
        ]  });
},


doSynchronousLoop:function(data, processData, done) {
    if (data.length > 0) {
        var loop = function(data, i, processData, done) {
            processData(data[i], i, function() {
                if (++i < data.length) {  setTimeout(function(){ loop(data, i, processData, done);  }, 0);
                } else {    done();    }  });  };
        loop(data, 0, processData, done); } else { done(); }
},



send_message_do:function(toast,index) {
    this.$snotify.remove(toast.id)
    this.isLoading=true;

    var query = "INSERT INTO myMEQ_MSG_MAIN (group_ID, msgMAIN_DATE,msgMAIN_SUBJECT,msgMAIN_MSG,staff_ID, msgMain_TYPE, msgMain_ATTACH) VALUES (" + this.group_id + ",'" + moment().format('YYYY-MM-DD HH:mm:SS') + "','" + this.msg_subject.replace( "'", "''") + "','" + this.msg_body.replace( "'", "''") + "'," + sessionStorage.getItem('user_ID') + ",'" + this.msg_type + "','" + this.msg_student_ids + "')"
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => { 
        this.doSynchronousLoop(this.data_students,this.send_sms, this.send_sms_end);
    })
    

},


send_sms_end:function() {
    setTimeout(() => { this.isLoading=false; this.emit_close_modal(true) }, 200)
},



send_confirm:function(sendType) {

    this.msg_type = sendType
    this.msg_addresses = ''
    this.msg_student_ids = ''

    if (sendType == 'EMAIL') {if (this.msg_subject.trim() == '') {alert('Enter sujet') ; return;}}
    if (this.msg_body.trim() == '') {alert('Enter message') ; return;}

    this.msg_from = "'" + sessionStorage.getItem('user_name') + "' <" + sessionStorage.getItem('user_email') + ">"

    this.msg_body_html = encodeURIComponent(this.msg_body.replace(/\n/g, "<br />"))
    console.log(this.msg_body_html)


    this.msg_count = 0
    var i; 
    for (i = 0; i < this.data_student.length; i++) {
       if (+this.data_student[i].goodToGo == true) 
       {   this.msg_count = +this.msg_count + 1
           this.msg_addresses += this.data_student[i].student_eMail + ","
           this.msg_student_ids += this.data_student[i].student_ID + ","}
    }
    if (this.msg_type == 'EMAIL') { this.msg_confirm_msg = 'envoyer ' + +this.msg_count + ' courriels'}
    else {this.msg_confirm_msg = 'envoyer ' + +this.msg_count + ' SMS'}

this.show_confirm = true 
},
 
send_sendIt:function() {
//SEND THAT S*&T
    if (this.msg_type == 'EMAIL') { this.send_email()}
    else {this.send_sms()}


},

send_sms:function(item, i, callback) {


                // item.isSent = true
                // callback()

       if (+item.goodToGo == true) {
        var ph = '+1' + item.student_TelOther.replace(/\D/g, "");
         axios.post(this.$url+'/sms_send?msg='+this.msg_body+'&to='+ph)
         .then(res => { 
                item.isSent = true
                callback()
             })
            }

        // this.show_confirm = false
        // this.get_message_history()

},


send_email:function() {
    //alert('here')
// STRING CONSTRUCTED ABOVE
    axios.post(this.$url+'/send_email_college?from='+encodeURIComponent(this.msg_from)+'&addresses='+this.msg_addresses+'&subject='+this.msg_subject+'&msgText='+this.msg_body+'&msgHtml='+this.msg_body_html)
    .then(res => { 
        this.show_confirm = false
        this.$snotify.success(' Email Sent !!', {
            timeout: 1000,showProgressBar: true,closeOnClick: false,pauseOnHover: false
        });       
        //this.get_message_history(true)
    })
},


send_email_XX:function() {
// STRING CONSTRUCTED ABOVE

var query = "INSERT INTO myMEQ_MSG_MAIN (group_ID, msgMAIN_DATE,msgMAIN_SUBJECT,msgMAIN_MSG,staff_ID, msgMain_TYPE, msgMain_ATTACH) VALUES (" + this.group_id + ",'" + moment().format('YYYY-MM-DD HH:mm:SS') + "','" + this.msg_subject.replace( "'", "''") + "','" + this.msg_body.replace( "'", "''") + "'," + sessionStorage.getItem('user_ID') + ",'" + this.msg_type + "','" + this.msg_student_ids + "')"
console.log(query)
axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
.then(res => { 
    console.log(res)
    //axios.get(this.$url+'/send_email_' + sessionStorage.getItem('college_nickname') + '?from='+encodeURIComponent(this.msg_from)+'&addresses='+this.msg_addresses+'&subject='+this.msg_subject+'&msgText='+this.msg_body+'&msgHtml='+this.msg_body_html)
    axios.get(this.$url+'/send_email_college?from='+encodeURIComponent(this.msg_from)+'&addresses='+this.msg_addresses+'&subject='+this.msg_subject+'&msgText='+this.msg_body+'&msgHtml='+this.msg_body_html)
    .then(res => { 
        this.show_confirm = false
        this.get_message_history(true)
    })
})



},



return_pic:function(pic) {
    return 'https://space-zytco.nyc3.digitaloceanspaces.com/photos/'+pic
},
// GENERATE A NEW ID! 
randomKey:function() {
return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
});},

}, // END METHODS


}
</script>

<style scoped>

</style>